import NodeController05ABI from "@abi/NodeController05";
import type { NodeResult } from "@hooks/useAllNodes";
import { useAppSelector } from "@store/hooks";
import { contractMigrationRequired } from "@store/selectors/contract";
import type { Address } from "viem";
import { useReadContracts } from "wagmi";
import useContract from "./useContract";
import { useTokenIds } from "./useTokenIds";
const useAllNodesRewards = (
	account: Address,
	nodes: NodeResult[],
): bigint[] => {
	const isMigrationRequired = useAppSelector(contractMigrationRequired);
	const { nodeController05Contract } = useContract();
	const idOfNfts = useTokenIds(account);

	const calls = nodes?.map((node, i) => {
		if (!node) {
			return null;
		}
		return {
			abi: NodeController05ABI,
			address: nodeController05Contract.address as Address,
			args: isMigrationRequired
				? [
						node.amount,
						+node.lastClaimTime?.toString(),
						+node.lastCompoundTime?.toString(),
					]
				: [idOfNfts?.[i]],
			functionName: isMigrationRequired
				? "getPendingRewards"
				: "getNodeRewards",
		};
	});

	const { data } = useReadContracts({
		allowFailure: false,
		contracts: calls,
	} as any);
	//@ts-expect-error:TODO
	return data?.map((result) => result ?? BigInt(0));
};

export default useAllNodesRewards;
